import filterSchema from './schema_filter';

function filterParsers(schema, available) {
   const wikitags = available.map(s => s.toLowerCase());
   const mapping = {
      emphasis: 'em',
      insert: 'underline',
      delete: 'strikethrough',
      quote: 'blockquote',
      linebreak: 'hard_break',
      code: 'code_block',
      teletype: 'code',
   };
   return filterSchema(schema, wikitags, mapping);
}

export default filterParsers;
